import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private overlayLoadingSubject = new BehaviorSubject<boolean>(false);
  overlayLoading$ = this.overlayLoadingSubject.asObservable();

  show() {
    this.overlayLoadingSubject.next(true);
  }

  hide() {
    this.overlayLoadingSubject.next(false);
  }
}
